"use client";

import { useEffect } from "react";
import Lenis from "lenis";

/** Eases wheel scrolling for the subtree it is mounted in. */
export function SmoothScroll(): null {
  useEffect(() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;
    const lenis = new Lenis({
      duration: 1.1,
      smoothWheel: true
    });
    let frame = requestAnimationFrame(function raf(time: number) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    });
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
}